import { render, staticRenderFns } from "./VCrudExpandable.vue?vue&type=template&id=4c4ee8bb"
import script from "./VCrudExpandable.vue?vue&type=script&lang=js"
export * from "./VCrudExpandable.vue?vue&type=script&lang=js"
import style0 from "./VCrudExpandable.vue?vue&type=style&index=0&id=4c4ee8bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports